    // src/.../sidebar/ContactSection.jsx
    import React from 'react';
    import PropTypes from 'prop-types';
    import { Box, Typography, TextField } from '@mui/material';

    function ContactSection({ value, readOnly = true, onChange }) {
    const rows = [
        { label: 'Fecha de Nacimiento', key: 'fechaNacimiento' },
        { label: 'Email',               key: 'email' },
        { label: 'Teléfono',            key: 'telefono' },
    ];

    return (
        <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Datos Personales</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            {rows.map(({ label, key }) => (
            readOnly ? (
                // en lectura: mostrar solo si hay valor
                value?.[key] ? (
                <Box key={key}>
                    <Typography variant="caption" color="text.secondary">{label}</Typography>
                    <Typography sx={{ mt: .5 }}>{value[key]}</Typography>
                </Box>
                ) : null
            ) : (
                // en edición: siempre input
                <TextField
                key={key}
                size="small"
                label={label}
                value={value?.[key] || ''}
                onChange={(e) => onChange((p) => ({ ...p, [key]: e.target.value }))}
                />
            )
            ))}
        </Box>
        </Box>
    );
    }

    ContactSection.propTypes = {
    value: PropTypes.object,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    };

    export default ContactSection;
